export default __webpack_public_path__ + "static/media/iconfinder-love.c19f48f2.svg";